import React from "react";
import ReactDOM from "react-dom";
import { AppContainer } from "react-hot-loader";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { App } from "./NewsApp/index";
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            staleTime: 0,
            networkMode: "always",
        },
    },
});
if (document.getElementById("app-news")) {
    ReactDOM.render(React.createElement(AppContainer, null,
        React.createElement(QueryClientProvider, { client: queryClient },
            React.createElement(App, null))), document.getElementById("app-news"));
}
